import React, { useState, useRef, useEffect } from "react";
import { Table, Container, Button } from "react-bootstrap";
import CustomPagination from "./../CustomPagination";
import axios from "axios";
import { format } from "date-fns";
import { Modal, ModalHeader, Form, Alert, Spinner } from "react-bootstrap";
import { Download, DownloadCloud } from "react-bootstrap-icons";
import { useAppContext } from "./../../contexts/AppContext";
import Select from "react-select";
import {
  queryBranches,
  queryGroups,
  queryUsers,
  getAllGroupMembers,
} from "../../services/poweruserServices";
const CoursesLst = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const ITEMS_PER_PAGE = useRef(25);

  //const { selectedCredit } =useAppContext();
  const [currentCourses, setCurrentCourses] = useState([]);
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  //const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [sortConfig, setSortConfig] = useState({
    key: "enrollment_completion_date",
    directionMap: { enrollment_completion_date: "desc" },
  });
  const [showResult, setShowResult] = useState(false);
  const [showResultPoPUp, setShowResultPoPUp] = useState("");
  const [successCoursesDetails, setSuccessCoursesDetails] = useState([]);
  const [failureCoursesDetails, setFailureCoursesDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [courseLoading, setCourseLoading] = useState(true);
  const [creditValue, setCreditValue] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const { currentUser } = useAppContext();
  const [prowerUserMsg, setProwerUserMsg] = useState(false);
  const [selectBoxValues, setSelectBoxValues] = useState();
  const [selectBoxValuesGroup, setSelectBoxValuesGroup] = useState();
  const [defaultListGroupOptions, setDefaultListGroupOptions] = useState([]);
  const [groupUsers, setGroupUsers] = useState([]);
  const [isListBoxLoading, setIsListBoxLoading] = useState(false);
  const [defaultListOptions, setDefaultListOptions] = useState([]);
  const [selectBoxValuesUser, setSelectBoxValuesUser] = useState(null);
  useEffect(() => {
    let resultToast = document.getElementById("resultToast");
    // added new code by excel soft to correcting the dessign issue the enroll complete popup
    let resultToastContainer = document.getElementById("resultToastContainer");
    if (showResult) {
      resultToast.classList.replace("hide", "show");
      resultToastContainer.classList.add(
        "position-fixed",
        "top-50",
        "start-50",
        "translate-middle",
        "d-flex",
        "justify-content-center",
        "align-items-center",
        "vw-100",
        "vh-100"
      );
    } else {
      resultToast.classList.replace("show", "hide");
      resultToastContainer.classList.remove(
        "position-fixed",
        "top-50",
        "start-50",
        "translate-middle",
        "d-flex",
        "justify-content-center",
        "align-items-center",
        "vw-100",
        "vh-100"
      );
    }

    setLoading(false);
  }, [showResult]);

  const handleSort = (key) => {
    setSortConfig((prev) => {
      const prevDirection = prev.directionMap[key] || "asc";
      const newDirection = prevDirection === "asc" ? "desc" : "asc";

      return {
        key,
        directionMap: {
          [key]: newDirection,
        },
      };
    });
  };

  useEffect(() => {
    const direction = sortConfig.directionMap[sortConfig.key] || "asc";

    const sortData = (data) => {
      return [...data].sort((a, b) => {
        const valA = a[sortConfig.key] ?? "";
        const valB = b[sortConfig.key] ?? "";

        if (sortConfig.key === "enrollment_completion_date") {
          return direction === "asc"
            ? new Date(valA) - new Date(valB)
            : new Date(valB) - new Date(valA);
        }

        return direction === "asc"
          ? valA.toString().localeCompare(valB.toString())
          : valB.toString().localeCompare(valA.toString());
      });
    };

    const source = filteredCourses.length > 0 ? filteredCourses : courses;
    const sortedCourses = sortData(source);

    setCurrentCourses(
      sortedCourses.slice(
        (currentPage - 1) * ITEMS_PER_PAGE.current,
        currentPage * ITEMS_PER_PAGE.current
      )
    );
  }, [sortConfig]);

  useEffect(() => {
    (async () => {
      console.log(currentUser);
      if (currentUser.isPowerUser) {
        setCourseLoading(false);
        setProwerUserMsg(true);
        defaultListGroupOptions.length <= 0 && getPowerUserGroups();
      } else {
        await getUserCourses();
      }
    })();
  }, []);

  const getPowerUserGroups = async () => {
    setIsListBoxLoading(true);
    let userGroups = await queryGroups(currentUser.user_id);

    var result = userGroups.map((item) => {
      return { value: item.id, label: item.name, type: "group" };
    });

    setDefaultListGroupOptions(result);
    setIsListBoxLoading(false);

    if (result.length > 0) {
      const firstGroup = result[0];
      setSelectBoxValuesGroup(firstGroup);
      await handleSelectChangeGroup(firstGroup);
    }

    return result;
  };
  const handleSelectChangeGroup = async (selectedOptions) => {
    setIsListBoxLoading(true);
    setSelectBoxValuesGroup(selectedOptions);
    //  console.log(selectedOptions);
    // let userGroups = await queryGroups(currentUser.user_id);
    let groupId = selectedOptions.value.toString();
    let groupUsers = await getAllGroupMembers(groupId);

    let listGroupUsers = groupUsers.map((item) => {
      return {
        
         value: item.id,
        label: item.username+" ( "+item.firstname+" "+item.lastname+" )",
        type: "user",
        email: item.email,
        firstname: item.firstname,
        lastname: item.lastname,
         username:item.username
      };
    });
    setGroupUsers(listGroupUsers);
    setDefaultListOptions(listGroupUsers);
    setIsListBoxLoading(false);
      setSelectedCourses([]);
    setSelectBoxValuesUser([]);
    return listGroupUsers;
  };
  const filterOptions = (candidate, input) => {
  const search = input.toLowerCase();

  return (
    candidate.data.label.toLowerCase().includes(search) ||
    candidate.data.email.toLowerCase().includes(search) ||
    candidate.data.value.toString().toLowerCase().includes(search) ||
    candidate.data.firstname.toLowerCase().includes(search) ||
      candidate.data.lastname.toLowerCase().includes(search) ||

      (candidate.data.firstname + ' ' + candidate.data.lastname)
          .toLowerCase()
          .includes(search)
  );
};
  const handleSelectChangeUser = async (selectedOptions) => {
    setCurrentPage(1);
    setCourseLoading(true);
    setSelectBoxValuesUser(selectedOptions);
    let userId = selectedOptions.value.toString();
    getUserCoursesByUserId(userId);
      setProwerUserMsg(false);
      setSelectedCourses([]);
  };
  const getUserCoursesByUserId = async (userId) => {
    setCreditValue("");
    setFilteredCourses([]);
    let params = new URL(document.location).searchParams;
    //let userId = params.get('user_id');
    //let userId = 30804
    await axios
      .post(
          `${process.env.REACT_APP_API_DOMAIN}/course/userenrolledcourse${window.location.search}`,
        {
          userId,
        },
        { withCredentials: true }
      )
      .then(async (response) => {
        var courseslst = response.data.rows;

        if (courseslst != null && courseslst.length > 0) {
          const courseDetails = await axios.post(
              `${process.env.REACT_APP_API_DOMAIN}/course/coursedetails${window.location.search}`,
            {
              CourseIds: [...new Set(courseslst.map((item) => item.course_id))],
            }
          );
          const courseMetaMap = new Map(
            courseDetails.data.map((course) => [
              course.CourseId,
              {
                Language: course.Language,
                Credits: course.Credits,
                EnrollmentPolicy: course.EnrollmentPolicy,
              },
            ])
          );

          // Merge data
          const mergedCourses = courseslst.map((enrollment) => {
            const meta = courseMetaMap.get(enrollment.course_id) || {};
            return {
              course_id: enrollment.course_id,
              course_name: enrollment.course_name,
              enrollment_completion_date: enrollment.enrollment_completion_date,
              Language: meta.Language || "-",
              Credits: meta.Credits ?? null,
              EnrollmentPolicy: meta.EnrollmentPolicy ?? 0,
              course_end_date: enrollment.course_end_date,
            };
          });
          const filteredCourses = mergedCourses.filter((course) => {
            if (course.course_end_date) {
              return true; // Include if course_end_date is not null
            }
            // Exclude if course_end_date is null AND EnrollmentPolicy is 0 or 1
            return !(
              course.EnrollmentPolicy === 0 || course.EnrollmentPolicy === 1
            );
          });

          setCourses(filteredCourses);
          setTotalPages(
            Math.ceil(filteredCourses.length / ITEMS_PER_PAGE.current)
          );
          setTotalRecords(filteredCourses.length);
          setCurrentCourses(
            filteredCourses.slice(
              (currentPage - 1) * ITEMS_PER_PAGE.current,
              currentPage * ITEMS_PER_PAGE.current
            )
          );
        } else {
          const coursedetails = []; // empty

          const courseMetaMap = new Map(
            coursedetails.map((course) => [
              course.CourseId,
              { Language: course.Language, Credits: course.Credits },
            ])
          );

          const mergedCourses = courseslst.map((enrollment) => {
            const meta = courseMetaMap.get(enrollment.course_id) || {};
            return {
              course_id: enrollment.course_id,
              course_name: enrollment.course_name,
              enrollment_completion_date: enrollment.enrollment_completion_date,
              Language: meta.Language || "-",
              Credits: meta.Credits ?? 0,
            };
          });

          setCourses(mergedCourses);
          setTotalPages(
            Math.ceil(mergedCourses.length / ITEMS_PER_PAGE.current)
          );
          setTotalRecords(mergedCourses.length);
          setCurrentCourses(
            mergedCourses.slice(
              (currentPage - 1) * ITEMS_PER_PAGE.current,
              currentPage * ITEMS_PER_PAGE.current
            )
          );
        }
      })
      .catch((err) => {
        console.error(err);
        setCourseLoading(false);
      });
    setCourseLoading(false);
  };
  const ClosePopUpHandlre = async () => {
    setShowResult(false);
    setShowResultPoPUp("");
    setFailureCoursesDetails([]);
    setSuccessCoursesDetails([]);
    setSelectedCourses([]);
    setCourseLoading(true);
    if (currentUser.isPowerUser) {
      let userId = selectBoxValuesUser.value.toString();
      getUserCoursesByUserId(userId);
    } else {
      await getUserCourses();
    }
  };
  const ReEnrollOkPopUpHandlre = async () => {
    if (currentUser.isPowerUser) {
      setShowResult(false);
      setShowResultPoPUp("");
      setFailureCoursesDetails([]);
      setSuccessCoursesDetails([]);
      setSelectedCourses([]);
      setCourseLoading(true);

      let userId = selectBoxValuesUser.value.toString();
      getUserCoursesByUserId(userId);
    } else {
      window.top.location.href =
          process.env.REACT_APP_COURSES_PAGE_URL;
    }
  };

  const getUserCourses = async () => {
    setCreditValue("");
    setFilteredCourses([]);
    let params = new URL(document.location).searchParams;
    let userId = params.get('user_id');
    //let userId = 30804;
    await axios
      .post(
          `${process.env.REACT_APP_API_DOMAIN}/course/userenrolledcourse${window.location.search}`,
        {
          userId,
        },
        { withCredentials: true }
      )
      .then(async (response) => {
        var courseslst = response.data.rows;
        console.log(courseslst);
        if (courseslst != null && courseslst.length > 0) {
          const courseDetails = await axios.post(
              `${process.env.REACT_APP_API_DOMAIN}/course/coursedetails${window.location.search}`,
            {
              CourseIds: [...new Set(courseslst.map((item) => item.course_id))],
            }
          );
          const courseMetaMap = new Map(
            courseDetails.data.map((course) => [
              course.CourseId,
              {
                Language: course.Language,
                Credits: course.Credits,
                EnrollmentPolicy: course.EnrollmentPolicy,
              },
            ])
          );

          // Merge data
          const mergedCourses = courseslst.map((enrollment) => {
            const meta = courseMetaMap.get(enrollment.course_id) || {};
            return {
              course_id: enrollment.course_id,
              course_name: enrollment.course_name,
              enrollment_completion_date: enrollment.enrollment_completion_date,
              Language: meta.Language || "-",
              Credits: meta.Credits ?? null,
              EnrollmentPolicy: meta.EnrollmentPolicy ?? 0,
              course_end_date: enrollment.course_end_date,
            };
          });
          const filteredCourses = mergedCourses.filter((course) => {
            if (course.course_end_date) {
              return true; // Include if course_end_date is not null
            }
            // Exclude if course_end_date is null AND EnrollmentPolicy is 0 or 1
            return !(
              course.EnrollmentPolicy === 0 || course.EnrollmentPolicy === 1
            );
          });

          setCourses(filteredCourses);
          setTotalPages(
            Math.ceil(filteredCourses.length / ITEMS_PER_PAGE.current)
          );
          setTotalRecords(filteredCourses.length);
          setCurrentCourses(
            filteredCourses.slice(
              (currentPage - 1) * ITEMS_PER_PAGE.current,
              currentPage * ITEMS_PER_PAGE.current
            )
          );
        } else {
          const coursedetails = []; // empty

          const courseMetaMap = new Map(
            coursedetails.map((course) => [
              course.CourseId,
              { Language: course.Language, Credits: course.Credits },
            ])
          );

          const mergedCourses = courseslst.map((enrollment) => {
            const meta = courseMetaMap.get(enrollment.course_id) || {};
            return {
              course_id: enrollment.course_id,
              course_name: enrollment.course_name,
              enrollment_completion_date: enrollment.enrollment_completion_date,
              Language: meta.Language || "-",
              Credits: meta.Credits ?? 0,
            };
          });

          setCourses(mergedCourses);
          setTotalPages(
            Math.ceil(mergedCourses.length / ITEMS_PER_PAGE.current)
          );
          setTotalRecords(mergedCourses.length);
          setCurrentCourses(
            mergedCourses.slice(
              (currentPage - 1) * ITEMS_PER_PAGE.current,
              currentPage * ITEMS_PER_PAGE.current
            )
          );
        }
      })
      .catch((err) => {
        console.error(err);
        setCourseLoading(false);
      });
    setCourseLoading(false);
  };

  useEffect(() => {
    setCurrentCourses(
      courses.slice(
        (currentPage - 1) * ITEMS_PER_PAGE.current,
        currentPage * ITEMS_PER_PAGE.current
      )
    );
  }, [currentPage]);

  const handlePageChange = (pageNumber, size) => {
    setCurrentPage(pageNumber);
    ITEMS_PER_PAGE.current = size;

    if (filteredCourses.length > 0) {
      setTotalPages(Math.ceil(filteredCourses.length / ITEMS_PER_PAGE.current));
      setTotalRecords(filteredCourses.length);
      setCurrentCourses(
        filteredCourses.slice(
          (pageNumber - 1) * ITEMS_PER_PAGE.current,
          pageNumber * ITEMS_PER_PAGE.current
        )
      );
    } else {
      setTotalPages(Math.ceil(courses.length / ITEMS_PER_PAGE.current));
      setTotalRecords(courses.length);
      setCurrentCourses(
        courses.slice(
          (pageNumber - 1) * ITEMS_PER_PAGE.current,
          pageNumber * ITEMS_PER_PAGE.current
        )
      );
    }
  };

  const handleCheckboxChange = (courseId) => {
    setSelectedCourses((prevSelected) =>
      prevSelected.includes(courseId)
        ? prevSelected.filter((id) => id !== courseId)
        : [...prevSelected, courseId]
    );
  };

  const handleBulkReEnroll = async () => {
    setLoading(true);
    if (selectedCourses.length > 4) {
      setShowResultPoPUp("validation");
      setShowResult(true);
    } else {
      setShowResultPoPUp("reenrollapicall");
      const selectedCourseDetails = courses.filter((course) =>
        selectedCourses.includes(course.course_id)
        );
        let params = new URL(document.location).searchParams;
      let userId = params.get('user_id');
      //let userId = 30804;
      if (currentUser.isPowerUser) {
        userId = selectBoxValuesUser.value.toString();
      }

      const userResp = await axios.post(
          `${process.env.REACT_APP_API_DOMAIN}/enrollment/reenroll_user_course${window.location.search}`,
        {
          userId: userId,
          courseIds: selectedCourseDetails.map((c) => c.course_id),
        },
        { withCredentials: true }
      );
      var success = userResp.data
        .filter((x) => x.status === "fulfilled")
        .map((x) => x.courseId);
      var failure = userResp.data
        .filter((x) => x.status === "rejected")
        .map((x) => x.courseId);

      setSuccessCoursesDetails(
        courses.filter((course) => success.includes(course.course_id))
      );
      setFailureCoursesDetails(
        courses.filter((course) => failure.includes(course.course_id))
      );

      setShowResult(true);
      setCourseLoading(true);
    }
    setLoading(false);
  };
  const formatEnrollmentDate = (date) => {
    return date ? format(new Date(date), "MMM dd, yyyy") : "-";
  };
  const getSortIcon = (key) => {
    //   if (sortConfig.key === key) {

    //     return sortConfig.direction === 'asc' ? '↑' : '↓';
    //   }
    //   return '↑'; // default icon
    if (sortConfig.key !== key) {
      return "⇅";
    }

    const direction = sortConfig.directionMap[key];

    if (!direction) return "⇅";
    return direction === "asc" ? "↑" : "↓";
  };
  const handleCreditChange = (event) => {
    let credit = event.target.value;
    setCreditValue(credit);
    if (credit == "") {
      setFilteredCourses([]);
      setCurrentPage(1);
      setCurrentCourses(
        courses.slice(
          (1 - 1) * ITEMS_PER_PAGE.current,
          1 * ITEMS_PER_PAGE.current
        )
      );
      setTotalPages(Math.ceil(courses.length / ITEMS_PER_PAGE.current));
      setTotalRecords(courses.length);
    } else {
      setCurrentPage(1);
      var searchedCourses = courses.filter(
        (course) => course.Credits === Number(credit)
      );
      setFilteredCourses(searchedCourses);
      setCurrentCourses(
        searchedCourses.slice(
          (1 - 1) * ITEMS_PER_PAGE.current,
          1 * ITEMS_PER_PAGE.current
        )
      );

      setTotalPages(Math.ceil(searchedCourses.length / ITEMS_PER_PAGE.current));
      setTotalRecords(searchedCourses.length);
    }
  };
  return (
    <div className="container-card">
      <div className="container-header">
        <div>
                  <div className="container-heading mt-1">Select Course(s) to Repeat</div>
          <div style={{ color: "#441968", font: "14px" }}>
          You may choose up to 4 courses to repeat at a time. Please review to ensure that you are not enrolling in more credit hours than you need to complete your training requirement. Once you have selected your course(s), click the Bulk Re-Enroll button.
          </div>
        </div>
      </div>
      <div className="container-card-body">
        <Container className="position-relative mt-4">
          {loading && (
            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-transparent z-100">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          )}
          {currentUser.isPowerUser && (
            <div className="d-flex justify-content-start align-items-center">
              <div style={{ width: "200px" }}>
                Select Group{" "}
                <Select
                  options={defaultListGroupOptions}
                  onChange={handleSelectChangeGroup}
                  isLoading={isListBoxLoading}
                  value={selectBoxValuesGroup}
                />
              </div>
              &nbsp;&nbsp;
              <div style={{ width: "300px" }}>
                Select Users{" "}
                <Select
                  options={defaultListOptions}
                  onChange={handleSelectChangeUser}
                  isLoading={isListBoxLoading}
                  value={selectBoxValuesUser}
                    filterOption={filterOptions}
                />
              </div>
            </div>
          )}

          <div className="d-flex justify-content-end align-items-center">
            <select
              value={creditValue}
              onChange={(event) => handleCreditChange(event)}
              style={{ width: 150, height: 36 }}
              className="form-select form-select-sm d-inline pe-2"
            >
              <option value="">Select Credits</option>

              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
            </select>{" "}
            &nbsp;&nbsp;
            <Button
              className="btn primary"
              disabled={selectedCourses.length === 0}
              onClick={handleBulkReEnroll}
            >
              Bulk Re-Enroll ({selectedCourses.length})
            </Button>
          </div>
          <div className=" table-responsive">
            <Table className="table align-middle">
              <thead>
                <tr>
                  <th>
                    {/* <input
                                    type="checkbox"
                                    checked={currentCourses.every(course => selectedCourses.includes(course.course_id))}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        const currentIds = currentCourses.map(course => course.course_id);
                                        setSelectedCourses((prevSelected) => {
                                            if (isChecked) {
                                                // Add all current page IDs that aren't already selected
                                                const newSelections = currentIds.filter(id => !prevSelected.includes(id));
                                                return [...prevSelected, ...newSelections];
                                            } else {
                                                // Remove current page IDs from selection
                                                return prevSelected.filter(id => !currentIds.includes(id));
                                            }
                                        });
                                    }}
                                /> Select All */}
                  </th>

                  <th
                    onClick={() => handleSort("course_name")}
                    style={{ cursor: "pointer" }}
                  >
                    Course Title &nbsp;
                    {getSortIcon("course_name")}
                  </th>

                  <th>Language</th>
                  <th
                    onClick={() => handleSort("enrollment_completion_date")}
                    style={{ cursor: "pointer", width: "163px" }}
                  >
                    Completion Date &nbsp;{" "}
                    {getSortIcon("enrollment_completion_date")}
                  </th>

                  <th>Credits</th>
                </tr>
              </thead>
              {currentCourses.length > 0 ? (
                courseLoading ? (
                  <tbody className=" text-center color-grey pt-5">
                    <tr>
                      <td colSpan={"5"} align="center">
                        <Spinner animation="border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {currentCourses.map((course, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="checkbox"
                              id={`checkbox-${index}`}
                            checked={selectedCourses.includes(course.course_id)}
                            onChange={() =>
                              handleCheckboxChange(course.course_id)
                            }
                             onKeyDown={(e) => {
                    if (e.key === "Enter") {
                    handleCheckboxChange(course.course_id)
                    }
                  }}
                          />
                        </td>
                        <td>{course.course_name}</td>
                        <td>
                          <div
                            className="text-dark"
                            style={{
                              borderRadius: "30px",
                              backgroundColor: "#ced4da",
                              display: "inline-block",
                              padding: "2px 10px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {course.Language}
                          </div>
                        </td>
                        <td>
                          {formatEnrollmentDate(
                            course.enrollment_completion_date
                          )}
                        </td>
                        <td>
                          <div
                            className="text-dark"
                            style={{
                              borderRadius: "30px",
                              backgroundColor: "#ced4da",
                              display: "inline-block",
                              padding: "2px 10px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {course.Credits}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )
              ) : courseLoading ? (
                <tbody className=" text-center color-grey pt-5">
                  <tr>
                    <td colSpan={"5"} align="center">
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody className="text-danger text-center color-grey pt-5">
                  <tr>
                    <td colSpan={"5"} align="center">
                      {prowerUserMsg == true
                        ? "Select Users To View Course"
                        : "No Courses found!"}
                    </td>
                  </tr>
                </tbody>
              )}
            </Table>
          </div>
          <div className="resultToastContainerClass" id="resultToastContainer">
            <div
              id="resultToast"
              className="toast hide"
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
              style={{ width: "450px" }}
            >
              {showResultPoPUp === "validation" && (
                <div>
                  <div className="toast-header">
                    {/* <img src="..." className="rounded me-2" alt="..." /> */}
                    <strong className="me-auto">Re-Enroll Failed</strong>
                    <small></small>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="toast"
                      aria-label="Close"
                      onClick={() => {
                        setShowResult(false);
                        setShowResultPoPUp("");
                      }}
                    ></button>
                  </div>
                  <div className="toast-body tostbodyclass">
                    <div>
                      <div className="toastpopup">
                        <span className="text-danger d-block fs-6">
                          You have selected more than <strong>4 courses</strong>{" "}
                          for Re-Enrollment. Reduce your selection to proceed.
                        </span>
                      </div>
                      <div
                        className="flex mt-3"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <button
                          className="btn btn-secondary"
                          onClick={() => {
                            setShowResult(false);
                            setShowResultPoPUp("");
                          }}
                        >
                          Ok
                        </button>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              )}
              {showResultPoPUp === "reenrollapicall" && (
                <div>
                  <div className="toast-header">
                    {/* <img src="..." className="rounded me-2" alt="..." /> */}
                    <strong className="me-auto">Re-Enroll Completed</strong>
                    <small></small>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="toast"
                      aria-label="Close"
                      onClick={async () => {
                        await ClosePopUpHandlre();
                      }}
                    ></button>
                  </div>
                  <div className="toast-body tostbodyclass">
                    <div>
                      <div className="toastpopup">
                        <span className="text-success d-block fs-6">
                          Successfully Re-Enrolled in{" "}
                          {successCoursesDetails.length} out of{" "}
                          {selectedCourses.length} Courses.
                          {successCoursesDetails.length > 0 && (
                            <div>
                              <span className="text-success d-block fs-6">
                                Re-enrolled in the following course(s):
                              </span>

                              <ul>
                                {successCoursesDetails.map((item) => (
                                  <li
                                    key={item.course_name}
                                    style={{
                                      color: "blue",
                                      fontSize: "smaller",
                                    }}
                                  >
                                    Course: {item.course_name}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                          {failureCoursesDetails.length > 0 && (
                            <div>
                              <span className="text-danger d-block fs-6">
                                Unable to Re-enroll in these Courses:
                              </span>

                              <ul>
                                {failureCoursesDetails.map((item) => (
                                  <li
                                    key={item.course_name}
                                    style={{
                                      color: "blue",
                                      fontSize: "smaller",
                                    }}
                                  >
                                    Course: {item.course_name}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </span>
                      </div>
                      <div
                        className="flex mt-3"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <button
                          className="btn btn-secondary"
                          onClick={async () => {
                            // setShowResult(false);
                            // setShowResultPoPUp("");
                            // setFailureCoursesDetails([]);
                            // setSuccessCoursesDetails([]);
                            // setSelectedCourses([]);
                            // setCourseLoading(true);
                            // await getUserCourses();
                            // window.top.location.href = 'https://seiu775bgsandbox1.docebosaas.com/pages/124/my-training'
                            await ReEnrollOkPopUpHandlre();
                          }}
                        >
                          Ok
                        </button>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              )}
            </div>
          </div>
          <CustomPagination
            totalPages={totalPages}
            totalRecords={totalRecords}
            onPageSizeChange={(size, page) => handlePageChange(page, size)}
            onPageChange={(page) => setCurrentPage(page)}
            currentPage={currentPage}
          />
        </Container>
      </div>
    </div>
  );
};

export default CoursesLst;
